import * as React from 'react';

import Form from './Form';
import HistoryRowData from './HistoryRowData';

import DocumentHeader from '../../../components/DocumentHeader';
import DocumentWrapper from '../../../components/DocumentWrapper';
import HistoryRow from '../../../components/HistoryRow';
import FormEditingHandler from '../../../containers/FormEditingHandler';
import HistoryRowControls from '../../../components/HistoryRowControls';
import { formatPartialDate } from 'Utility/date';
import { sortPartialDate } from 'neuro-utils';
import DocumentCreationButton from '../../../components/DocumentCreationButton';

const GeneralHealth = ({ documents }: IOwnProps): React.JSX.Element => {
  return (
    <FormEditingHandler name="generalhealth" documents={documents}>
      {(editing, startEdit, formData): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name="generalhealth"
            headerId={'generalhealth.title'}
            editing={editing}
            editButtons={
              <div>
                <DocumentCreationButton
                  name="generalhealth"
                  text={'generalhealth.newGeneralHealth'}
                  onClick={startEdit({})}
                />
              </div>
            }
          />
          {!editing && documents
            ? documents
                .toSorted((n1, n2) => sortPartialDate(n2.date, n1.date))
                .map((d: IGeneralHealth) => (
                  <HistoryRow
                    headerText={d.date ? formatPartialDate(d.date) : undefined}
                    key={d._id}
                    rowButton={<HistoryRowControls document={d} startEdit={startEdit} />}
                    controlsMargin={false}
                  >
                    <HistoryRowData d={d} />
                  </HistoryRow>
                ))
            : undefined}
          {editing ? <Form formData={formData} editing={editing} /> : undefined}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents?: IGeneralHealth[];
}

export default GeneralHealth;
